module.exports = __webpack_public_path__ + "static/media/train-card10.b913d9e7.jpg";